import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Helmet } from "react-helmet";
import { buildUrlWithLang } from "@/lib/utils";

const Hero = () => {
  const { language, t } = useLanguage();

  const heroImageSchema = {
    "@context": "https://schema.org",
    "@type": "ImageObject",
    "contentUrl": "https://www.kareemtaxi.co.mz/images/motorista-yango-maputo-1024.avif",
    "url": "https://www.kareemtaxi.co.mz/",
    "name": "Cadastro Motorista Yango Maputo",
    "caption": "Cadastro motorista Yango Maputo - Criar conta Yango com Kareem Taxi parceiro oficial - Inscrição rápida em 10 minutos",
    "description": "Imagem de motorista Yango em Maputo mostrando oportunidade de cadastro e criação de conta com Kareem Taxi, parceiro oficial Yango em Moçambique",
    "creator": {
      "@type": "Organization",
      "@id": "https://www.kareemtaxi.co.mz/#org"
    },
    "author": { "@id": "https://www.kareemtaxi.co.mz/#org" },
    "publisher": { "@id": "https://www.kareemtaxi.co.mz/#org" },
    "creditText": "Kareem Taxi - Parceiro Oficial Yango",
    "copyrightNotice": "© 2025 Kareem Taxi",
    "license": "https://www.kareemtaxi.co.mz/termos-de-uso#imagens",
    "acquireLicensePage": "https://wa.me/258853448609?text=Gostaria%20de%20adquirir%20licença%20para%20uso%20de%20imagem",
    "keywords": "cadastro motorista Yango Maputo, criar conta Yango, parceiro oficial Yango, inscrição motorista Yango Moçambique"
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(heroImageSchema)}
        </script>
      </Helmet>
      <section
      id="home"
      className="
        relative
        h-auto
        min-h-[calc(100svh-5rem)]
        lg:min-h-screen
        flex flex-col lg:grid lg:grid-cols-2
        overflow-visible
        pt-28 lg:pt-32
        scroll-mt-24
      "
    >
      {/* Left: Driver Recruitment Content */}
      <div className="bg-background flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-16 pb-10 md:py-12 lg:py-20">
        <div className="w-full max-w-3xl mx-auto text-center lg:text-left lg:mx-0">
          <h1
            className="
              text-3xl sm:text-4xl md:text-5xl lg:text-6xl
              font-bold mb-5
              leading-[1.2]
              break-words
              lg:pr-8 text-foreground
            "
          >
            {t("hero.title")}
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-col items-center lg:items-start gap-6">
            <Button
              size="lg"
              className="
                w-full sm:w-auto
                whitespace-normal break-words
                text-lg px-6 py-4
                bg-primary text-primary-foreground hover:bg-primary/90
                font-bold tracking-wide
              "
              onClick={() => {
                window.open(
                  "https://forms.fleet.yango.com/forms?specification=taxi&ref_id=b6140518c1b9412f9df3576a9f32d6d1&utm_source=google&utm_medium=cpc&utm_campaign=motors_car_search&lang=pt",
                  "_blank",
                );
              }}
            >
              {t("hero.driverCard.cta")}
            </Button>
            
            <div className="flex flex-wrap gap-4 justify-center lg:justify-start text-sm">
              <a href={buildUrlWithLang('/cadastro-motorista-yango', language)} className="text-muted-foreground hover:text-primary underline transition-colors">
                {language === 'pt' ? 'Ver guia completo de cadastro →' : 'See complete registration guide →'}
              </a>
              <a href={buildUrlWithLang('/requisitos-motorista-yango', language)} className="text-muted-foreground hover:text-primary underline transition-colors">
                {language === 'pt' ? 'Requisitos necessários →' : 'Required requirements →'}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Right: Hero Image */}
      <div className="relative w-full mt-6 lg:mt-0 aspect-[2/3] lg:aspect-auto lg:h-screen">
        <picture className="block w-full h-full">
          <source
            type="image/avif"
            srcSet="/images/motorista-yango-maputo-320.avif 320w,
                    /images/motorista-yango-maputo-480.avif 480w,
                    /images/motorista-yango-maputo-640.avif 640w,
                    /images/motorista-yango-maputo-1024.avif 1024w"
            sizes="(max-width: 374px) 320px,
                   (max-width: 639px) 480px,
                   (max-width: 767px) 640px,
                   640px"
          />
          <source
            type="image/webp"
            srcSet="/images/motorista-yango-maputo-320.webp 320w,
                    /images/motorista-yango-maputo-480.webp 480w,
                    /images/motorista-yango-maputo-640.webp 640w,
                    /images/motorista-yango-maputo.webp 1024w"
            sizes="(max-width: 374px) 320px,
                   (max-width: 639px) 480px,
                   (max-width: 767px) 640px,
                   640px"
          />
          <img
            src="/images/motorista-yango-maputo.webp"
            alt="Motorista profissional Yango em Maputo com veículo preparado para transporte"
            title="Cadastro Motorista Yango Maputo | Criar Conta Yango | Kareem Taxi - Parceiro Oficial"
            className="w-full h-full object-cover object-right"
            width="1024"
            height="1536"
            loading="eager"
            fetchPriority="high"
            decoding="sync"
          />
        </picture>
      </div>
    </section>
    </>
  );
};

export default Hero;
